import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Typography,
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { CustomizedBox } from "../../../Custom/CustomizedBox";

const NewContactCard = ({
  onEdit,
  onRemove,
  index,
  img,
  imgAlt,
  title,
  initial,
  first_name,
  last_name,
  nickname,
  subcontent,
  viewOnly,
  isSalesList,
}) => {
  const { t } = useTranslation();
  const [anchorPos, setAnchorPos] = useState(null);
  const showActions = Boolean(anchorPos);

  const openActionsHandler = (event) => {
    setAnchorPos(event.currentTarget);
  };

  const closeActionsHandler = () => {
    setAnchorPos(null);
  };

  const editHandler = () => {
    setAnchorPos(null);
    onEdit(index);
  };

  return (
    <>
      <Menu
        anchorEl={anchorPos}
        open={showActions}
        onClose={closeActionsHandler}
      >
        {!isSalesList && (
          <MenuItem onClick={editHandler}>{viewOnly ? "ดู" : "แก้ไข"}</MenuItem>
        )}
        {!viewOnly && (
          <MenuItem onClick={() => onRemove(index)}>
            {t("contact.utility.delete")}
          </MenuItem>
        )}
      </Menu>
      <CustomizedBox sx={{ py: "1.5rem", px: "2rem" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Avatar
              alt={imgAlt}
              src={typeof img !== "object" ? img : img?.preview}
            />
            <Typography variant="body1" marginLeft={2}>
              {title}
            </Typography>
          </Box>
          {!isSalesList && (
            <IconButton
              onClick={openActionsHandler}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <MoreVertIcon />
            </IconButton>
          )}
          {isSalesList && !viewOnly && (
            <IconButton
              onClick={openActionsHandler}
              sx={{
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <MoreVertIcon />
            </IconButton>
          )}
        </Box>

        <Box sx={{ display: "flex", mt: 2, mb: subcontent ? 2 : 6.5 }}>
          {initial && (
            <Typography
              variant="body2"
              sx={{ mr: 0.5, color: (theme) => theme.palette.grey[700] }}
            >
              {initial}
            </Typography>
          )}
          {first_name && (
            <Typography
              variant="body2"
              sx={{ mr: 2, color: (theme) => theme.palette.grey[700] }}
            >
              {first_name}
            </Typography>
          )}
          {first_name && last_name && (
            <Typography
              variant="body2"
              sx={{ color: (theme) => theme.palette.grey[700] }}
            >
              {last_name}
            </Typography>
          )}
          {!first_name && nickname && (
            <Typography
              variant="body2"
              sx={{ color: (theme) => theme.palette.grey[700] }}
            >
              {nickname}
            </Typography>
          )}
        </Box>
        {subcontent && (
          <Typography
            variant="body2"
            sx={{ my: 2, color: (theme) => theme.palette.grey[700] }}
          >
            {subcontent}
          </Typography>
        )}
      </CustomizedBox>
    </>
  );
};

export default NewContactCard;
